import React, { useState, useMemo } from "react";
import { Box, Paper, Tab, Tabs, Typography } from "@mui/material";
import Layout from "../../layout/layout";
import Organizations from "./organizations";
import ClientSetup from "./setupclient";
import ListUser from "./userList";
import EnvSetup from "./envSetup";
import AccountDetails from "./accountDetails";
import KeyConfiguration from "./keyConfiguration";

const TABS = [
  { value: "5", label: "Client", component: <ClientSetup /> },
  { value: "4", label: "Organization", component: <Organizations /> },
  { value: "6", label: "Account Details", component: <AccountDetails /> },
  // { value: "0", label: "Users", component: <ListUser /> },
  { value: "1", label: "Env Setup", component: <EnvSetup /> },
  { value: "3", label: "Key Configuration", component: <KeyConfiguration /> },
];

const Setup = () => {
  const [tabValue, setTabValue] = useState("5");
  const activeTab = TABS.find((tab) => tab.value === tabValue) || TABS[0];

    const pageTitle = useMemo(() => {
  try {
    const menus = JSON.parse(sessionStorage.getItem('userMenus') || '[]');
    const matchedMenu = menus.find(
      (m) => m.path?.toLowerCase() === '/settings'
    );
    return matchedMenu?.label ?? null;
  } catch {
    return null;
  }
}, []);

  return (
    <Layout pageType="sideBar">
      <Box sx={{ px: { xs: 1, md: 2 }, pb: 3 }}>
        <Box sx={{ mb: 1 }}>
          <Typography variant="title">
             {pageTitle && (
  <Typography variant="title" sx={{ m: 0 }}>
    {pageTitle}
</Typography>
)}
            </Typography>
        </Box>

        <Tabs
          value={tabValue}
          onChange={(event, newValue) => setTabValue(newValue)}
          TabIndicatorProps={{
            style: {
              backgroundColor: "#1976d2",
              height: "2px",
            },
          }}
          sx={{
            minHeight: "48px",
            backgroundColor: "transparent",
            border: "none",
            "& .MuiTab-root": {
              textTransform: "none",
              fontSize: "14px",
              fontWeight: 500,
              color: "#5c6b7d",
              padding: "12px 14px",
              minWidth: "auto",
            },
            "& .Mui-selected": {
              color: "#1976d2 !important",
            },
          }}
        >
          {TABS.map((tab) => (
            <Tab key={tab.value} value={tab.value} label={tab.label} />
          ))}
        </Tabs>

        <Paper sx={{ borderRadius: 2, px: 2, pt: 2, pb: 2 }}>
          <Box sx={{ minHeight: "calc(100vh - 270px)" }}>
            {activeTab.component}
          </Box>
        </Paper>
      </Box>
    </Layout>
  );
};

export default Setup;
